import moment from 'moment';
import { DATE_TIME_FORMAT_DEFAUT } from 'Config';

export const DATE_TOKEN = '{datahora}';

/**
 * Replaces the {datahora} token in the message with the event datetime formatted in the
 * VIEWER's local timezone. The instant is stored in UTC, so PT shows the chosen hour,
 * France shows +1h and the Azores -1h automatically — no timezone library needed
 * (moment formats in the device's local timezone). If there is no event datetime, the
 * token is stripped.
 */
export function applyDateToken(message?: string | null, eventAt?: string | Date | null): string {
    if (!message) {
        return '';
    }
    if (!eventAt) {
        return message.split(DATE_TOKEN).join('');
    }
    const formatted = moment(eventAt).format(DATE_TIME_FORMAT_DEFAUT);
    return message.split(DATE_TOKEN).join(formatted);
}
